import { VIEW } from "interfaces"

export enum PAGE_TITLES {
    HOME = "Home",
    SINGLE_COUNTRY_RISKS = "Single Country Risks",
    MULTI_COUNTRY_RISKS = "Compare Countries",
    BILATERAL_RISKS = "Bilateral Risks",
    ANALYSIS_AND_PREDICTIONS = "Analysis & Predictions",
    CREATE_INSIGHT = "Create Insight",
    EVENT_SCORING = "Event Scoring",
    METHODOLOGIES = "Methodologies"
}

export const getCategoryForPiwik = (viewType: VIEW) => {
    if(viewType ===  VIEW.COUNTRY_GRAPH){
        return PAGE_TITLES.SINGLE_COUNTRY_RISKS
    }
    if([VIEW.WORLD_GRAPH, VIEW.SORT_BY_RISK, VIEW.SORT_BY_DELTA, VIEW.HEATMAP].includes(viewType)){
        return PAGE_TITLES.MULTI_COUNTRY_RISKS
    }
    if([VIEW.SORT_BY_CONTINGENT_DELTA, VIEW.SORT_BY_CONTINGENT_RISK, VIEW.CONTINGENT_GRAPH].includes(viewType)){
        return PAGE_TITLES.BILATERAL_RISKS
    }
}

